<div class="tv-startup-screen">
  <div class="tv-startup-logo">
    <svg class="tv-startup-frame" width="178" height="116" viewBox="0 0 178 116" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path d="M162.94 0H5.66C2.53 0 0 2.53 0 5.66V102.7C0 105.83 2.53 108.36 5.66 108.36H162.94C166.07 108.36 168.6 105.83 168.6 102.7V5.66C168.6 2.53 166.07 0 162.94 0ZM164.12 100.45C164.12 102.84 162.18 104.78 159.79 104.78H8.81C6.42 104.78 4.48 102.84 4.48 100.45V7.91C4.48 5.52 6.42 3.58 8.81 3.58H159.79C162.18 3.58 164.12 5.52 164.12 7.91V100.46V100.45Z" fill="#406CA4"/>
      <path d="M171.82 6.71997H14.5499C11.4199 6.71997 8.88989 9.24997 8.88989 12.38V109.42C8.88989 112.55 11.4199 115.08 14.5499 115.08H171.83C174.96 115.08 177.49 112.55 177.49 109.42V12.38C177.49 9.24997 174.96 6.71997 171.83 6.71997H171.82ZM173 107.18C173 109.57 171.06 111.51 168.67 111.51H17.6899C15.2999 111.51 13.3599 109.57 13.3599 107.18V14.63C13.3599 12.24 15.2999 10.3 17.6899 10.3H168.67C171.06 10.3 173 12.24 173 14.63V107.18Z" fill="#B1454B"/>
    </svg>
    <img class="tv-startup-marquee" src="assets/images/tv-startup-caremoni-text.png" alt="" aria-hidden="true" />
  </div>
  <ng-container *ngIf="isLoading; else startupError">
    <div class="tv-startup-status">
      <span>ただいま処理中です</span><span class="tv-startup-dot" aria-hidden="true">。</span>
    </div>
  </ng-container>
  <ng-template #startupError>
    <div class="tv-startup-error">{{ errorMessage }}</div>
  </ng-template>
</div>
